export default "__VITE_ASSET__DFBsWFlr__"